import { Stack } from '@mui/material';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { MobileTitle } from '../../../../components/style/TextStyle';
import { useAuthAxios } from '../../../../hooks/useAuthAxios';
import { useYupValidationResolver } from '../../../../hooks/useYupValidationResolver';
import { responsiveMargin } from '../../../../utils/enum';
import { CreateStatusForm } from '../Common/CreateCategoryForm';
import {
  statusDefaultValue,
  statusSchema,
} from '../Common/DefaultValuesAndSchema';
import AddMobileCategoryButton from './AddMobileCategoryButton';
import { GoBackIconButton } from './GoBackIconButton';

export default function StatusCategoryMobile() {
  const resolver = useYupValidationResolver(
    Yup.object().shape({
      ...statusSchema,
    }),
  );

  const form = useForm<any>({
    mode: 'onTouched',
    resolver,
    defaultValues: {
      ...statusDefaultValue,
    },
    shouldUnregister: false,
  });

  const [postStatusResult, postStatus] = useAuthAxios({
    method: 'POST',
    url: '/api/v1/inspectionResultType',
  });

  const onSubmit = form.handleSubmit(function (values) {
    const payload = {
      title: values.title,
      notes: values.notes,
    };
    postStatus({ data: payload });
  });

  return (
    <Stack mx={responsiveMargin} spacing={5} my={{ xs: 2, md: 10 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <GoBackIconButton form={form} />
        <MobileTitle>상태 추가</MobileTitle>
        <AddMobileCategoryButton
          title="상태 추가"
          onSubmit={onSubmit}
          postResult={postStatusResult}
        />
      </Stack>
      <CreateStatusForm form={form} />
    </Stack>
  );
}
